(function ($) {
    var M = window.MDMeals;
    if (!M || !M.api) {
        return;
    }
    if (document.getElementById('md-account-logged-in')) {
        return;
    }
    var acc = window.mdMealAccount || {};
    var root = document.querySelector('.md-meals-account');
    if (!root) {
        return;
    }
    if (root.getAttribute('data-account-js') === '0') {
        return;
    }

    var STATUS_SLOT_CLASS = 'md-acc-card-status';
    var panels = {
        signupGate: document.getElementById('md-account-panel-signup-gate'),
        signup: document.getElementById('md-account-panel-signup'),
        welcome: document.getElementById('md-account-panel-welcome'),
        signin: document.getElementById('md-account-panel-signin'),
        otp: document.getElementById('md-account-panel-otp'),
    };
    var $formGate = $('#md-account-form-invite-gate');
    var $formSu = $('#md-account-form-signup');
    var $formLi = $('#md-account-form-signin');
    var $formOtp = $('#md-account-form-otp');
    var gateCleared = !acc.inviteRequired;
    var validatedInviteCode = '';
    var postSignupSession = false;
    var previousView = null;
    var pendingOtpFromSignup = null;
    var otpTickInterval = null;
    var otpExpiresAtMs = 0;
    var otpResendAvailableAtMs = 0;
    var otpIssuedOnce = false;
    var OTP_RESEND_COOLDOWN_MS = 60 * 1000;
    var OTP_VALID_MS = 15 * 60 * 1000;

    var signinMode = 'code';
    var $signinPwWrap = $('#md-acc-li-pw-wrap');
    var $signinSubmit = $('#md-acc-signin-submit');
    var $toggleSigninPw = $('#md-acc-toggle-pw');
    var $toggleSigninCode = $('#md-acc-toggle-code');

    function digitsOnlyPhone(val) {
        return String(val || '')
            .replace(/\D/g, '')
            .slice(0, 11);
    }

    function identifierKind(val) {
        var s = String(val || '').trim();
        if (s.indexOf('@') >= 0) {
            return 'email';
        }
        if (digitsOnlyPhone(s).length >= 7) {
            return 'phone';
        }
        return 'unknown';
    }

    function updateSigninUi() {
        if (!$formLi.length) {
            return;
        }
        var idEl = document.getElementById('md-acc-li-id');
        if (!idEl) {
            return;
        }
        var kind = identifierKind(idEl.value);
        if (kind === 'email' && signinMode === 'code') {
            signinMode = 'password';
        }
        $formLi.attr('data-signin-mode', signinMode);
        var isPw = signinMode === 'password';
        if ($signinPwWrap.length) {
            if (isPw) {
                $signinPwWrap.removeAttr('hidden');
            } else {
                $signinPwWrap.attr('hidden', 'hidden');
            }
        }
        if ($signinSubmit.length) {
            $signinSubmit.text(isPw ? 'Sign in' : 'Send code');
        }
        if ($toggleSigninPw.length && $toggleSigninCode.length) {
            if (kind === 'phone') {
                if (isPw) {
                    $toggleSigninPw.attr('hidden', 'hidden');
                    $toggleSigninCode.removeAttr('hidden');
                } else {
                    $toggleSigninPw.removeAttr('hidden');
                    $toggleSigninCode.attr('hidden', 'hidden');
                }
            } else {
                $toggleSigninPw.attr('hidden', 'hidden');
                $toggleSigninCode.attr('hidden', 'hidden');
            }
        }
    }

    function accountBaseUrl() {
        var u = acc.accountUrl || window.location.pathname;
        return u.replace(/\/?$/, '/');
    }

    function replaceStepParam(step) {
        try {
            var cur = new URL(window.location.href);
            cur.searchParams.delete('step');
            if (acc.pretty && acc.accountUrl) {
                var nu = new URL(accountBaseUrl() + step + '/', window.location.origin);
                cur.searchParams.forEach(function (val, key) {
                    nu.searchParams.set(key, val);
                });
                window.history.replaceState({}, '', nu.pathname + (nu.search || ''));
            } else {
                cur.searchParams.set('step', step);
                window.history.replaceState({}, '', cur.toString());
            }
        } catch (e) {}
    }

    function panelElForView(view) {
        if (view === 'signup-gate') {
            return panels.signupGate;
        }
        if (view === 'signup') {
            return panels.signup;
        }
        if (view === 'welcome') {
            return panels.welcome;
        }
        if (view === 'signin') {
            return panels.signin;
        }
        if (view === 'otp') {
            return panels.otp;
        }
        return null;
    }

    function clearHiddenPanelStatusSlots() {
        Object.keys(panels).forEach(function (k) {
            var el = panels[k];
            if (!el || !el.hasAttribute('hidden')) {
                return;
            }
            var slot = el.querySelector('[data-md-acc-status]');
            if (!slot) {
                return;
            }
            slot.textContent = '';
            slot.setAttribute('hidden', 'hidden');
            slot.className = STATUS_SLOT_CLASS;
        });
    }

    function showStatus(msg, isError) {
        var panelEl = panelElForView(previousView);
        if (!panelEl) {
            return;
        }
        var slot = panelEl.querySelector('[data-md-acc-status]');
        if (!slot) {
            return;
        }
        slot.textContent = msg || '';
        slot.className = STATUS_SLOT_CLASS + (isError ? ' is-error' : '');
        if (msg) {
            slot.removeAttribute('hidden');
        } else {
            slot.setAttribute('hidden', 'hidden');
        }
    }

    function setPanelHidden(el, hide) {
        if (!el) {
            return;
        }
        if (hide) {
            el.setAttribute('hidden', 'hidden');
        } else {
            el.removeAttribute('hidden');
        }
    }

    function clearOtpTimers() {
        if (otpTickInterval) {
            clearInterval(otpTickInterval);
            otpTickInterval = null;
        }
    }

    function formatCountdown(ms) {
        if (ms <= 0) {
            return '0:00';
        }
        var s = Math.ceil(ms / 1000);
        var m = Math.floor(s / 60);
        var r = s % 60;
        return m + ':' + (r < 10 ? '0' : '') + r;
    }

    function resetOtpSendUi() {
        clearOtpTimers();
        otpExpiresAtMs = 0;
        otpResendAvailableAtMs = 0;
        otpIssuedOnce = false;
        var sendBtn = document.getElementById('md-acc-otp-send');
        var hint = document.getElementById('md-acc-otp-send-hint');
        var expEl = document.getElementById('md-acc-otp-expires');
        if (sendBtn) {
            sendBtn.disabled = false;
            sendBtn.textContent = 'Send verification code';
        }
        if (hint) {
            hint.textContent = '';
        }
        if (expEl) {
            expEl.textContent = '';
            expEl.setAttribute('hidden', 'hidden');
        }
    }

    function tickOtpSendUi() {
        var sendBtn = document.getElementById('md-acc-otp-send');
        var expEl = document.getElementById('md-acc-otp-expires');
        var now = Date.now();
        if (expEl && otpExpiresAtMs) {
            var left = otpExpiresAtMs - now;
            if (left <= 0) {
                expEl.textContent =
                    'That code has expired. Tap Resend to get a new one (codes always expire 15 minutes after they are sent).';
                expEl.removeAttribute('hidden');
            } else {
                expEl.textContent =
                    'Code expires in ' +
                    formatCountdown(left) +
                    '. After it expires, tap Resend for a new code.';
                expEl.removeAttribute('hidden');
            }
        }
        if (sendBtn) {
            if (now < otpResendAvailableAtMs) {
                sendBtn.disabled = true;
                sendBtn.textContent =
                    (otpIssuedOnce ? 'Resend code' : 'Send verification code') +
                    ' (' +
                    formatCountdown(otpResendAvailableAtMs - now) +
                    ')';
            } else {
                sendBtn.disabled = false;
                sendBtn.textContent = otpIssuedOnce ? 'Resend code' : 'Send verification code';
            }
        }
    }

    function afterOtpIssued(r, opts) {
        opts = opts || {};
        var hint = document.getElementById('md-acc-otp-send-hint');
        var dev = r.dev_code ? ' (dev: ' + r.dev_code + ')' : '';
        if (hint) {
            if (opts.fromSignup) {
                hint.textContent =
                    'We sent a code when you created your account. Enter it below, or wait for the timer and tap Resend for a new code.';
            } else {
                hint.textContent =
                    'Code sent. Check your phone or email for a 4-digit code. It expires in 15 minutes.' + dev;
            }
        }
        var expSec = parseInt(r.expires_at, 10);
        otpExpiresAtMs = expSec ? expSec * 1000 : Date.now() + OTP_VALID_MS;
        otpResendAvailableAtMs = Date.now() + OTP_RESEND_COOLDOWN_MS;
        otpIssuedOnce = true;
        clearOtpTimers();
        tickOtpSendUi();
        otpTickInterval = setInterval(tickOtpSendUi, 1000);
    }

    function showView(view) {
        if (view !== 'otp' && previousView === 'otp') {
            clearOtpTimers();
        }
        if (view === 'otp' && previousView !== 'otp') {
            resetOtpSendUi();
            if (pendingOtpFromSignup) {
                var expMs = pendingOtpFromSignup.expires_at * 1000;
                if (pendingOtpFromSignup.expires_at && Date.now() < expMs) {
                    afterOtpIssued(
                        {
                            expires_at: pendingOtpFromSignup.expires_at,
                            dev_code: pendingOtpFromSignup.dev_code,
                        },
                        { fromSignup: true }
                    );
                } else {
                    pendingOtpFromSignup = null;
                }
            }
        }
        previousView = view;
        setPanelHidden(panels.signupGate, view !== 'signup-gate');
        setPanelHidden(panels.signup, view !== 'signup');
        setPanelHidden(panels.welcome, view !== 'welcome');
        setPanelHidden(panels.signin, view !== 'signin');
        setPanelHidden(panels.otp, view !== 'otp');
        if (view === 'signin') {
            replaceStepParam('signin');
        } else if (view === 'signup' || view === 'signup-gate') {
            replaceStepParam(view === 'signup-gate' ? 'gate' : 'signup');
        } else if (view === 'otp') {
            replaceStepParam('otp');
        } else if (view === 'welcome') {
            replaceStepParam('welcome');
        }
        if (view === 'signin') {
            updateSigninUi();
        }
        clearHiddenPanelStatusSlots();
    }

    function getRedirect() {
        var $h = $formOtp.find('input[name="redirect_to"]');
        if ($h.length && $h.val()) {
            return $h.val();
        }
        $h = $formLi.find('input[name="redirect_to"]');
        if ($h.length && $h.val()) {
            return $h.val();
        }
        $h = $formSu.find('input[name="redirect_to"]');
        return $h.length && $h.val() ? $h.val() : '';
    }

    function parsleyOk($form) {
        if (!$form.length || typeof $form.parsley !== 'function') {
            return true;
        }
        return $form.parsley().validate();
    }

    $(document).on('input', '.md-input-phone', function () {
        var el = this;
        var v = digitsOnlyPhone(el.value);
        if (el.value !== v) {
            el.value = v;
        }
    });

    function copyPhoneToOtp(fromSu) {
        var raw;
        if (fromSu) {
            raw = $formSu.find('[name="phone"]').val();
        } else {
            raw = $formLi.find('[name="identifier"]').val() || '';
        }
        var ph = digitsOnlyPhone(raw);
        var otpPhone = document.getElementById('md-acc-otp-phone');
        if (otpPhone && !otpPhone.readOnly) {
            otpPhone.value = ph;
        }
    }

    function gotoSigninWithPhoneFromSignup() {
        var ph = $formSu.find('[name="phone"]').val();
        $formLi.find('[name="identifier"]').val(digitsOnlyPhone(ph));
        signinMode = 'code';
        updateSigninUi();
        $('#md-acc-switch-to-signup').removeAttr('hidden');
        showView('signin');
        showStatus('That email or phone is already registered. Sign in with a code or password.');
        try {
            var u = new URL(window.location.href);
            u.searchParams.set('from', 'signup-existing');
            window.history.replaceState({}, '', u.toString());
        } catch (e) {}
    }

    var initial = root.getAttribute('data-initial-step') || 'signin';
    if (initial === 'gate' && acc.inviteRequired && panels.signupGate) {
        showView('signup-gate');
    } else if (initial === 'signup' && acc.inviteRequired && !gateCleared && panels.signupGate) {
        showView('signup-gate');
    } else if (initial === 'signup') {
        showView('signup');
    } else if (initial === 'otp') {
        showView('otp');
    } else if (initial === 'welcome') {
        showView('welcome');
    } else {
        showView('signin');
    }

    $(document).on('click', '[data-md-acc-step]', function (e) {
        e.preventDefault();
        var step = $(this).data('md-acc-step');
        showStatus('');
        if (step === 'signin') {
            $('#md-acc-switch-to-signup').attr('hidden', 'hidden');
            showView('signin');
        } else if (step === 'signup') {
            $('#md-acc-switch-to-signin').attr('hidden', 'hidden');
            if (acc.inviteRequired && !gateCleared && panels.signupGate) {
                showView('signup-gate');
            } else {
                showView('signup');
            }
        }
    });

    if ($formGate.length) {
        $formGate.on('submit', function (e) {
            e.preventDefault();
            if (!parsleyOk($formGate)) {
                return;
            }
            showStatus('');
            var fd = new FormData($formGate[0]);
            var code = fd.get('code');
            M.api('auth/invite/check', {
                method: 'POST',
                body: { code: code },
            })
                .then(function () {
                    gateCleared = true;
                    validatedInviteCode = String(code || '');
                    showView('signup');
                })
                .catch(function (err) {
                    showStatus(String(err.message || err), true);
                });
        });
    }

    if ($formSu.length) {
        $formSu.on('submit', function (e) {
            e.preventDefault();
            if (!parsleyOk($formSu)) {
                return;
            }
            showStatus('');
            var fd = new FormData($formSu[0]);
            var body = {
                first_name: fd.get('first_name'),
                last_name: fd.get('last_name'),
                email: fd.get('email'),
                phone: fd.get('phone'),
                password: fd.get('password') || '',
                sms_consent: fd.get('sms_consent') ? true : false,
            };
            if (acc.inviteRequired) {
                body.invite_code = validatedInviteCode;
            } else {
                body.invite_code = '';
            }
            M.api('auth/signup', {
                method: 'POST',
                body: body,
            })
                .then(function (r) {
                    var parts = [];
                    parts.push(
                        r.otp_sent
                            ? 'Account created. Check your phone for a verification code (optional).'
                            : 'Account created.'
                    );
                    if (r.dev_code) {
                        parts.push('(dev: ' + r.dev_code + ')');
                    }
                    if (r.otp_sent && r.otp_expires_at) {
                        pendingOtpFromSignup = {
                            expires_at: r.otp_expires_at,
                            dev_code: r.dev_code || null,
                        };
                    } else {
                        pendingOtpFromSignup = null;
                    }
                    copyPhoneToOtp(true);
                    var fn = fd.get('first_name');
                    var wh = document.getElementById('md-acc-welcome-heading');
                    if (wh && fn) {
                        wh.textContent = 'Welcome, ' + String(fn) + '!';
                    }
                    var otpNote = document.getElementById('md-acc-welcome-otp-note');
                    if (otpNote && r.otp_sent) {
                        otpNote.textContent =
                            'We sent a 4-digit code to your phone — it expires in 15 minutes. You can verify now or finish your profile first.';
                        otpNote.removeAttribute('hidden');
                    } else if (otpNote) {
                        otpNote.textContent = '';
                        otpNote.setAttribute('hidden', 'hidden');
                    }
                    postSignupSession = true;
                    showView('welcome');
                    showStatus(parts.join(' '));
                })
                .catch(function (err) {
                    var code = err.code;
                    if (code === 'phone_exists' || code === 'email_exists') {
                        $('#md-acc-switch-to-signin').removeAttr('hidden');
                        gotoSigninWithPhoneFromSignup();
                        return;
                    }
                    showStatus(String(err.message || err), true);
                });
        });
    }

    if ($formLi.length) {
        updateSigninUi();
        $(document).on('input', '#md-acc-li-id', function () {
            if (identifierKind(this.value) === 'email') {
                signinMode = 'password';
            }
            updateSigninUi();
        });
        $(document).on('click', '#md-acc-toggle-pw', function (e) {
            e.preventDefault();
            signinMode = 'password';
            updateSigninUi();
        });
        $(document).on('click', '#md-acc-toggle-code', function (e) {
            e.preventDefault();
            signinMode = 'code';
            updateSigninUi();
        });
        $formLi.on('submit', function (e) {
            e.preventDefault();
            if (!parsleyOk($formLi)) {
                return;
            }
            var fd = new FormData($formLi[0]);
            var idRaw = String(fd.get('identifier') || '').trim();
            var kind = identifierKind(idRaw);
            if (kind === 'email') {
                signinMode = 'password';
            }
            updateSigninUi();
            if (signinMode === 'password') {
                var pwc = String(fd.get('password') || '');
                if (!pwc) {
                    showStatus('Enter your password.', true);
                    var pwi = document.getElementById('md-acc-li-pw');
                    if (pwi) {
                        pwi.focus();
                    }
                    return;
                }
                showStatus('');
                M.api('auth/login-password', {
                    method: 'POST',
                    body: {
                        identifier: idRaw,
                        password: pwc,
                        redirect_to: getRedirect() || '',
                    },
                })
                    .then(function (resp) {
                        if (resp && resp.next_url) {
                            window.location.href = resp.next_url;
                            return;
                        }
                        window.location.reload();
                    })
                    .catch(function (err) {
                        if (err.code === 'no_password') {
                            signinMode = 'code';
                            updateSigninUi();
                            showStatus(
                                'No password on file. Enter your phone to receive a one-time code, then tap Send code.',
                                true
                            );
                        } else {
                            showStatus(String(err.message || err), true);
                        }
                    });
                return;
            }
            if (kind !== 'phone') {
                showStatus('Enter a valid mobile phone number to receive a code.', true);
                var ide1 = document.getElementById('md-acc-li-id');
                if (ide1) {
                    ide1.focus();
                }
                return;
            }
            var phone = digitsOnlyPhone(idRaw);
            if (phone.length < 7) {
                showStatus('Enter a valid mobile phone number to receive a code.', true);
                return;
            }
            showStatus('');
            M.api('auth/login-otp', {
                method: 'POST',
                body: { phone: phone },
            })
                .then(function (r) {
                    var dev = r.dev_code ? ' (dev: ' + r.dev_code + ')' : '';
                    copyPhoneToOtp(false);
                    showView('otp');
                    showStatus('Code sent.' + dev);
                    afterOtpIssued(r);
                    $('#md-acc-switch-to-signup').attr('hidden', 'hidden');
                    try {
                        var u = new URL(window.location.href);
                        u.searchParams.delete('from');
                        window.history.replaceState({}, '', u.toString());
                    } catch (e) {}
                    var codeInput = document.getElementById('md-acc-code');
                    if (codeInput) {
                        codeInput.focus();
                    }
                })
                .catch(function (err) {
                    var code = err.code;
                    if (code === 'not_found') {
                        $('#md-acc-switch-to-signup').removeAttr('hidden');
                        if (acc.inviteRequired && !gateCleared && panels.signupGate) {
                            showView('signup-gate');
                        } else {
                            showView('signup');
                        }
                        try {
                            var u = new URL(window.location.href);
                            u.searchParams.set('from', 'signin-not-found');
                            window.history.replaceState({}, '', u.toString());
                        } catch (e2) {}
                        showStatus('No account for that phone yet. Create one below.', true);
                    } else {
                        showStatus(String(err.message || err), true);
                    }
                });
        });
    }

    $(document).on('click', '#md-acc-otp-send', function () {
        var sendBtn = document.getElementById('md-acc-otp-send');
        var phoneEl = document.getElementById('md-acc-otp-phone');
        if (!sendBtn || !phoneEl) {
            return;
        }
        var phone = digitsOnlyPhone(phoneEl.value);
        if (!phone) {
            showStatus('Enter your phone number first.', true);
            phoneEl.focus();
            return;
        }
        phoneEl.value = phone;
        var panel = document.getElementById('md-account-panel-otp');
        var helperEmail = panel ? panel.getAttribute('data-otp-email') || '' : '';
        var body = { phone: phone };
        if (helperEmail) {
            body.email = helperEmail;
        } else {
            var tryEmail = $formSu.find('[name="email"]').val();
            if (tryEmail) {
                body.email = tryEmail;
            }
        }
        showStatus('');
        sendBtn.disabled = true;
        sendBtn.textContent = 'Sending…';
        M.api('auth/otp', { method: 'POST', body: body })
            .then(function (r) {
                afterOtpIssued(r);
                var codeInput = document.getElementById('md-acc-code');
                if (codeInput) {
                    codeInput.value = '';
                    codeInput.focus();
                }
            })
            .catch(function (err) {
                showStatus(String(err.message || err), true);
                if (otpIssuedOnce) {
                    tickOtpSendUi();
                } else {
                    sendBtn.disabled = false;
                    sendBtn.textContent = 'Send verification code';
                }
            });
    });

    if ($formOtp.length) {
        $formOtp.on('submit', function (e) {
            e.preventDefault();
            if (!parsleyOk($formOtp)) {
                return;
            }
            showStatus('');
            var fd = new FormData($formOtp[0]);
            M.api('auth/verify', {
                method: 'POST',
                body: {
                    phone: fd.get('phone'),
                    code: fd.get('code'),
                    redirect_to: getRedirect() || '',
                },
            })
                .then(function (resp) {
                    pendingOtpFromSignup = null;
                    var fromWelcome = false;
                    try {
                        fromWelcome = (new URL(window.location.href)).searchParams.get('from') === 'welcome';
                    } catch (e) {}
                    if (fromWelcome) {
                        var accUrl = (acc && acc.accountUrl) || '/account/';
                        if (resp && resp.profile_complete) {
                            window.location.href = accUrl;
                            return;
                        }
                        try {
                            var wu = new URL(accUrl, window.location.origin);
                            wu.pathname = wu.pathname.replace(/\/?$/, '/') + 'welcome/';
                            wu.searchParams.set('saved', 'phone');
                            window.location.href = wu.toString();
                        } catch (e2) {
                            window.location.href = accUrl + 'welcome/?saved=phone';
                        }
                        return;
                    }
                    if (resp && resp.next_url) {
                        window.location.href = resp.next_url;
                        return;
                    }
                    var red = getRedirect();
                    if (red) {
                        window.location.href = red;
                    } else if (postSignupSession) {
                        showView('welcome');
                        showStatus('Phone verified.');
                    } else {
                        window.location.reload();
                    }
                })
                .catch(function (err) {
                    showStatus(String(err.message || err), true);
                });
        });
    }

    $(document).on('click', '#md-acc-otp-skip', function (e) {
        e.preventDefault();
        showView('welcome');
    });

    $(document).on('click', '#md-acc-welcome-verify', function () {
        showView('otp');
        var codeInput = document.getElementById('md-acc-code');
        if (codeInput) {
            codeInput.focus();
        }
    });

    $(document).on('click', '#md-acc-goto-signin', function (e) {
        e.preventDefault();
        gotoSigninWithPhoneFromSignup();
    });

    $(document).on('click', '#md-acc-goto-signup', function (e) {
        e.preventDefault();
        $('#md-acc-switch-to-signup').attr('hidden', 'hidden');
        if (acc.inviteRequired && !gateCleared && panels.signupGate) {
            showView('signup-gate');
        } else {
            showView('signup');
        }
        showStatus('');
        try {
            var u = new URL(window.location.href);
            u.searchParams.delete('from');
            window.history.replaceState({}, '', u.toString());
        } catch (e) {}
    });
})(jQuery);
